export const INCREMENT_SYNONYM_SCORE = /* GraphQL */ `
    mutation incrementSynonymScore(
        $request_id: String!
        $action: SynonymScoreAction!
    ) {
        incrementSynonymScore(request_id: $request_id, action: $action) {
            success
            message
            candidates_updated
        }
    }
`
